// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdoptionChart from './AdoptionChart';
import AdoptionChartLegend from './AdoptionChartLegend';
// css
import '../../styles/components/analytics/Adoption.scss';


class Adoption extends Component {
  constructor(props) {
    super(props);
  }

  getSelectedArea() {
    if (!this.props.areas) {
      return { title: ''};
    }
    return this.props.areas.find(a => a.id === parseInt(this.props.params.areaId));
  }

  render() {
    const adoptionGoals = this.props.adoptionGoalsByArea;
    const selectedArea = this.getSelectedArea();

    return (
      <div className='analytics__adoption'>
        <h2>Adoption Chart: { selectedArea.title }</h2>
        <div className='chart' id={this.props.pptxTarget}>
          <AdoptionChart
            selectedArea={this.props.params.areaId}
            goals={adoptionGoals.goals}
            groups={adoptionGoals.groups}
            values={adoptionGoals.values}
          />
          <AdoptionChartLegend />
        </div>
      </div>
    );
  }
}

Adoption.propTypes = {
  areas: PropTypes.array,
  params: PropTypes.object.isRequired,
  adoptionGoalsByArea: PropTypes.object.isRequired,
  pptxTarget: PropTypes.string
};

export default Adoption;



// WEBPACK FOOTER //
// ./src/components/analytics/Adoption.js